import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-price-label',
    template: `
        <span class="{{color}}" *ngIf="price || price === 0">
            {{ displaySign && price > 0 ? '+' : '' }}{{ price | number: '1.2-2' }} {{ currency }}
        </span>
    `
})
export class PriceLabelComponent implements OnInit {

    @Input() price: number;
    @Input() currency = '€';
    @Input() color: string;
    @Input() displaySign = false;

    constructor() {
    }

    ngOnInit() {
    }
}
